import { useMutation, useQueryClient } from "@tanstack/react-query"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function deleteWorkflow(workflowId: string): Promise<void> {
  return api.delete(`/explorer/workflow/${workflowId}`)
}

export function useDeleteWorkflow() {
  const queryClient = useQueryClient()

  const deleteWorkflowMutation = useMutation({
    mutationKey: queryKeys.deleteWorkflow,
    mutationFn: (workflowId: string) => deleteWorkflow(workflowId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.workflows })
    },
  })

  return deleteWorkflowMutation
}
